export function getGroupColor(groupNumber) {
  switch (groupNumber) {
    // Red
    case 1:
      return "#FF4747";
    case 11:
      return "#FF7575";
    case 21:
      return "#FEA3A3";
    case 31:
      return "#FFD1D1";
    case 41:
      return "#FF1919";
    case 51:
      return "#EA0000";
    case 61:
      return "#BC0000";
    case 71:
      return "#8E0000";
    case 81:
      return "#600000";
    case 91:
      return "#330000";
    // Orange
    case 2:
      return "#FFB547";
    case 12:
      return "#FFC775";
    case 22:
      return "#FFDAA3";
    case 32:
      return "#FFECD1";
    case 42:
      return "#FFA319";
    case 52:
      return "#EA8C00";
    case 62:
      return "#BC7100";
    case 72:
      return "#8E5500";
    case 82:
      return "#603A00";
    case 92:
      return "#331E00";
    // Yellow   
    case 3:
      return "#DAFF47";
    case 13:
      return "#E3FF75";
    case 23:
      return "#ECFEA3";
    case 33:
      return "#F5FFD1";
    case 43:
      return "#D1FF19";
    case 53:
      return "#BBEA00";
    case 63:
      return "#96BC00";
    case 73:
      return "#728E00";
    case 83:
      return "#4D6000";
    case 93:
      return "#283300";
    // Green #003314, #006026, #008c39, #00bc4b, #00ea5d, #19ff75, #47ff90, #75ffac, #a3f3c7, #d1ffe3   
    case 4:
      return "#47FF90";
    case 14:
      return "#75FFAC";
    case 24:
      return "#A3F3C7";
    case 34:
      return "#D1FFE3";
    case 44:
      return "#19FF75";
    case 54:
      return "#00EA5D";
    case 64:
      return "#00BC4B";
    case 74:
      return "#008C39";
    case 84:
      return "#006026";
    case 94:
      return "#003314";
    // cyan #003233, #006060, #008e8e, #00bcbc, #00eaea, #19feff, #47feff, #75feff, #a3fefe, #d1ffff
    case 5:
      return "#47FEFF";
    case 15:
      return "#75FEFF";
    case 25:
      return "#A3FEFE";
    case 35:
      return "#D1FFFF";
    case 45:
      return "#19FEFF";
    case 55:
      return "#00EAEA";
    case 65:
      return "#00BCBC";
    case 75:
      return "#008E8E";
    case 85:
      return "#006060";
    case 95:
      return "#003233";
    // blue #001433, #002660, #00398e, #004bbc, #005dea, #1975ff, #4790ff, #75acff, #a3c7fe, #d1e3ff   
    case 6:
      return "#4790FF";
    case 16:
      return "#75ACFF";
    case 26:
      return "#A3C7FE";
    case 36:
      return "#D1E3FF";
    case 46:
      return "#1975FF";
    case 56:
        return "#005DEA";
    case 66:
      return "#004BBC";
    case 76:
      return "#00398E";
    case 86:
      return "#002660";
    case 96:
      return "#001433";
    // Indigo #0a0033, #130060, #1c008e, #2500bc, #2e00ea, #4719ff, #6c47ff, #9075ff, #b5a3fe, #dad1ff
    case 7:
      return "#6C47FF";
    case 17:
      return "#9075FF";
    case 27:
      return "#B5A3FE";
    case 37:
      return "#DAD1FF";
    case 47:
      return "#4719FF";
    case 57:
      return "#2E00EA";
    case 67:
      return "#2500BC";
    case 77:
      return "#1C008E";
    case 87:
      return "#130060";
    case 97:
      return "#0A0033";
    // Violet #280033, #4d0060, #72008e, #9600bc, #bb00ea, #d119ff, #da47ff, #e375ff, #eca3fe, #f5d1ff
    case 8:
      return "#DA47FF";
    case 18:
      return "#E375FF";
    case 28:
      return "#ECA3FE";
    case 38:
      return "#F5D1FF";
    case 48:
      return "#D119FF";
    case 58:
      return "#BB00EA";
    case 68:
      return "#9600BC";
    case 78:
      return "#72008E";
    case 88:
      return "#4D0060";
    case 98:
      return "#280033";
    //crimson #33001e, #60003a, #8e0055, #bc0071, #ea008c, #ff19a3, #ff47b5, #ff75c7, #fea3da, #ffd1ec
    case 9:
      return "#FF47B5";
    case 19:
      return "#FF75C7";
    case 29:
      return "#FEA3DA";
    case 39:
      return "#FFD1EC";
    case 49:
      return "#FF19A3";
    case 59:
      return "#EA008C";
    case 69:
      return "#BC0071";
    case 79:
      return "#8E0055";
    case 89:
      return "#60003A";
    case 99:
      return "#33001E";
    // brown #221406, #41260b, #613911, #804b16, #9f5d1c, #be7021, #d9822b, #df944a, #e4a769, #eab989
    case 10:
      return "#d9822b";
    case 20:
      return "#df944a";
    case 30:
      return "#e4a769";
    case 40:
      return "#eab989";
    case 50:
      return "#be7021";
    case 60:
      return "#9f5d1c";
    case 70:
      return "#804b16";
    case 80:
      return "#613911";
    case 90:
      return "#41260b";
    case 100:
      return "#221406";
    default:
      return "#000000";
  }
}
